import client from '@stores/apollo'
import gql from 'graphql-tag'

import handleFetchResult from '@utils/handleFetchResult'

interface UpdateBookingManagerDeptInput {
  id: string
  bookingsManagerSetting: {
    managed_departments_ids: string[]
    managed_employees_ids: string[]
    manage_all: boolean
  }
  role: string
}

interface IPayload {
  updateEmployee: {
    employee: {
      user: {
        bookingsManagerSetting: {
          managed_departments_ids: []
          managed_departments: any
          manage_all: boolean
        }
      }
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, any>({
  handler: (data) => data.updateEmployee.employee.user.bookingsManagerSetting,
  name: 'BookingManagerSettings',
})

export default function updateDeptEmpForBookingManager(input: UpdateBookingManagerDeptInput): any {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation UpdateEmployee($input: UpdateEmployeeInput!) {
    updateEmployee(input: $input) {
      employee {
        user {
          bookingManagerSetting: bookingsManagerSetting {
            managed_employees {
              id
              name
            }
            managed_departments {
              id
              name
              color
              colors
            }
            manage_all
          }
        }
      }
    }
  }
`
